import type { PropsWithChildren } from 'react'
import { NextStepProvider } from 'nextstepjs'
import { ProductGalleryOnboardingController } from './ProductGalleryOnboardingController'
import './product-gallery-onboarding.scss'

export function ProductGalleryOnboarding({ children }: Readonly<PropsWithChildren>) {
  return (
    <NextStepProvider>
      <ProductGalleryOnboardingController>
        {children}
      </ProductGalleryOnboardingController>
    </NextStepProvider>
  )
}
